import React from 'react';
import ModalAction from '../ModalAction';
import ModalSkeleton from '../ModalSkeleton';
import classes from './AlertModal.module.css';
const AlertModal = ({
  onConfirm,
  content,
  children,
  title,
  show,
  setShow,
  loading,
  onCancel,
  width = '408px',
  actions = true
}) => {
  return (
    <ModalSkeleton
      padding={'12px 20px'}
      gapBetweenHeadAndBody="8px"
      borderRadius="8px"
      width={width}
      title={title}
      show={show}
      position="top"
      setShow={setShow}>
      {content && <p className={classes.content}>{content}</p>}
      {children && <div>{children}</div>}
      {actions && (
        <ModalAction
          isApiCall={loading}
          className={classes.actions}
          onCancel={() => {
            if (typeof onCancel === 'function') onCancel();
            setShow(false);
          }}
          onConfirm={onConfirm}
        />
      )}
    </ModalSkeleton>
  );
};

export default AlertModal;
